import { createStyles, Stack, Text } from '@mantine/core';
import React, { ReactNode } from 'react';

import { SignupWizardContextDataType } from '../wizard/wizard.types';

interface ClassificationCardProps {
  onSelect: (
    classification: SignupWizardContextDataType['classification']
  ) => void;
  icon: ReactNode;
  label: string;
  description: string;
  classification: SignupWizardContextDataType['classification'];
}
export function ClassificationCard({
  label,
  onSelect,
  icon,
  description,
  classification,
}: ClassificationCardProps) {
  const { classes } = useStyles();

  return (
    <Stack
      className={classes.container}
      onClick={() => onSelect(classification)}
      spacing={0}
      align="center"
    >
      {icon}

      <Text
        size="xl"
        weight={600}
        className={classes.label}
        mt={36}
        data-testid={`classification-card-${label}`}
      >
        {label}
      </Text>

      <Text
        size="sm"
        weight={600}
        mt="xs"
        align="center"
        className={classes.description}
      >
        {description}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    width: 350,
    height: 350,
    border: `2px solid ${theme.colors.blue_gray[0]}`,
    position: 'relative',
    padding: theme.spacing.xl,
    borderRadius: theme.radius.lg,
    transition: 'all 0.15s ease-in-out',
    cursor: 'pointer',

    '&:hover': {
      boxShadow: '0px 11px 18px rgba(38, 50, 56, 0.1)',
    },

    svg: {
      width: '100%',
      height: 150,
      mixBlendMode: 'revert',
    },
  },

  label: {
    color: theme.colors.blue_gray[9],
  },

  description: {
    color: theme.colors.blue_gray[5],
  },
}));
